import { render } from "./UserListItem.vue?vue&type=template&id=246b3bbe&scoped=true"
import script from "./UserListItem.vue?vue&type=script&lang=js"
export * from "./UserListItem.vue?vue&type=script&lang=js"

import "./UserListItem.vue?vue&type=style&index=0&id=246b3bbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246b3bbe"]])

export default __exports__